module.exports = __webpack_public_path__ + "img/Vue.03b3867f.svg";